import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { AccountsManagerContext } from 'shared/contexts/accounts-manager'
import { Modal } from '../modal'
import { useHistory } from 'react-router'
import { giphyDarkestGrey, giphyLightGrey } from '@giphy/js-brand'
import { useLocalStorage } from 'react-use'

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 50px 15px;
    width: 500px;
    height: 243px;
    background: ${giphyDarkestGrey};
    border-radius: 8px;
`

const EmulatedChannelAvatar = styled.img`
    position: absolute;
    width: 58px;
    height: 58px;
    border-radius: 2px;
    top: -29px;
`

const Title = styled.h2`
    font-family: 'nexablack', sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 28px;
`

const Description = styled.p`
    font-family: 'interface';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;

    span {
        font-weight: bold;
    }
`

const Button = styled.button`
    width: 250px;
    height: 41px;
    background: linear-gradient(88.24deg, #9933ff -20.09%, #6157ff 98.56%);
    border-radius: 2px;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    margin-top: 25px;
`

const SecondaryButton = styled.button`
    font-family: 'interface';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: ${giphyLightGrey};
`

const ChannelAccessModal = () => {
    const [confirmedChannelAccessId, setConfirmedChannelAccessId] = useLocalStorage<number>(
        'confirmed-channel-access-id',
        undefined
    )
    const { channel_access } = useContext(AccountsManagerContext)
    const { location } = useHistory()

    useEffect(() => {
        if (!channel_access?.emulated_user || channel_access?.emulated_user.id !== confirmedChannelAccessId) {
            setConfirmedChannelAccessId(0)
        }
    }, [channel_access])

    if (channel_access?.emulated_user && confirmedChannelAccessId !== channel_access.emulated_user.id) {
        return (
            <Modal>
                <Container>
                    <EmulatedChannelAvatar src={channel_access?.emulated_user.avatar_url} alt={'Channel Image'} />
                    <Title>Switching Accounts!</Title>
                    <Description>
                        {`You’re now browsing as `}
                        <span>
                            {channel_access.emulated_user?.display_name || channel_access.emulated_user?.username}
                        </span>
                        .
                    </Description>
                    <Button onClick={() => setConfirmedChannelAccessId(channel_access.emulated_user?.id)}>
                        Continue
                    </Button>
                    <SecondaryButton
                        onClick={() => {
                            window.location.href = `/api/v4/channels/access/logout?next=${location.pathname}`
                        }}
                    >
                        Change back to {channel_access.user.display_name || channel_access.user.username}
                    </SecondaryButton>
                </Container>
            </Modal>
        )
    } else {
        return <></>
    }
}

export default ChannelAccessModal
